import cn from 'classnames';

import StatusIcon, { PossibleStatusDataVariant } from '@shared/components/StatusIcon/StatusIcon.tsx';

import styles from './DataStatus.module.scss';

interface DataStatusProps {
  variant: PossibleStatusDataVariant;
  textLabel: string;
  wrapperClassName?: string;
  textLabelClassName?: string;
}

export function DataStatus({ variant, textLabel, wrapperClassName, textLabelClassName }: DataStatusProps) {
  return (
    <div className={cn(styles.wrapper, wrapperClassName)}>
      <StatusIcon variant={variant} />
      <span className={cn(styles.label, textLabelClassName)}>{textLabel}</span>
    </div>
  );
}
